export default "__VITE_ASSET__PYnbF1V8__"